<template>
  <div class="fb-patient-dose-spot-active-medications-v1">
    <div v-if="showType == 'form-builder'" :style="properties.style">
      <b-form-group
        :description="computedPropertiesForm.description"
        :label="computedPropertiesForm.label"
        :style="properties.style"
      >
        <b-table
          responsive
          :items="tableProperties.items"
          :fields="tableProperties.columns"
        ></b-table>
      </b-form-group>
    </div>
    <div v-else-if="showType == 'properties'">
      <patient-dose-spot-active-medications-v1-properties :formId="formId" />
    </div>
    <div
      v-if="
        (showType == 'form-submitter' && page == currentPage) ||
        (showType == 'e-form' && properties.eFormEditable)
      "
      :style="properties.style"
      class="medication-table-container"
      v-show="!computedHidden"
    >
      <b-form-group
        :description="computedPropertiesForm.description"
        :style="properties.style"
      >
        <template v-slot:label="">
          <div class="d-flex align-items-center justify-content-between">
            <span style="font-size: 16px" class="mr-3">
              {{
                computedPropertiesForm.label
              }}
            </span>
            <b-button @click="fetchMedications" variant="primary" class="mr-2"
              ><i class="fa fa-sync-alt mr-2"></i> Reload Active
              Medications</b-button
            >
          </div>
        </template>
        <b-table
          class="custom-fb-table"
          responsive
          striped
          hover
          :items="tableProperties.items"
          :fields="tableProperties.columns"
        >
        </b-table>
        <div v-if="doseSpotErrorMessage" class="text-danger text-center">
          {{ doseSpotErrorMessage }}
        </div>
      </b-form-group>
    </div>
    <div
      v-if="showType == 'form-viewer'"
      :style="properties.style"
      class="medication-table-container"
    >
      <b-table
          responsive
          :items="tableProperties.items"
          :fields="tableProperties.columns"
        ></b-table>
      <div v-if="doseSpotErrorMessage" class="text-danger text-center">{{doseSpotErrorMessage}}</div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import PatientDoseSpotActiveMedicationsV1Properties from "./PatientDoseSpotActiveMedicationsV1Properties.vue";
import doseSpotServer from "../../../../server/doseSpot";

export default {
  name: "PatientDoseSpotActiveMedicationsV1",
  components: { PatientDoseSpotActiveMedicationsV1Properties },
  props: ["showType", "properties", "form", "id", "formId", "page", "componentsIdSuffix"],
  data() {
    return {
      doseSpotErrorMessage: null,
      medications: [],
      computedProperties: ["description", "label", "hidden"],
      computedConditions: {},
    };
  },
  async mounted() {
    if (this.showType != "form-builder") {
      if (
        this.getFormSubmitterComponentValue(this.id) &&
        this.showType == "form-submitter"
      ) {
        const value = this.getFormSubmitterComponentValue(this.id);
        this.medications = value.medications;
        this.doseSpotErrorMessage = value.error;
      } else if (this.showType == "form-submitter") {
        this.fetchMedications();
      }
    }

    this.computeConditions();
    this.$emit("mount-done");
  },
  methods: {
    ...mapActions("formSubmitter", ["setFormSubmitterComponentValue", "initializeComponentValue"]),
    computeConditions() {
      const computedConditions = {};
      for (let index = 0; index < this.computedProperties.length; index++) {
        const property = this.computedProperties[index];
        computedConditions[property] =
          typeof this.properties[property] == "string" &&
          this.properties[property].includes("{{");
      }
      this.computedConditions = computedConditions;
    },
    getComponentComputedProperties(property) {
      return this.computedPropertiesForm
        ? this.computedPropertiesForm[property] != null
          ? this.computedPropertiesForm[property]
          : this.properties[property]
          ? this.properties[property]
          : ""
        : this.properties[property]
        ? this.properties[property]
        : "";
    },
    getBakedLayout() {
      const hidden = this.getComponentComputedProperties("hidden");

      if (hidden === true) return "";

      this.setFormSubmitterComponentValue({
        controlId: this.id,
        controlValue: {
          medications: this.medications,
          error: this.doseSpotErrorMessage,
        },
        userAction: true,
        hardSet: true,
      });
      return `
      <fieldset aria-describedby="" class="form-group is-table" id="__BVID__48">
        <legend style="font-size:16px;" tabindex="-1" class="bv-no-focus-ring col-form-label pt-0" id="__BVID__48__BV_label_">${this.getComponentComputedProperties(
          "label"
        )}</legend>
        <div tabindex="-1" role="group" class="bv-no-focus-ring">
          <div>
            <div>
              <table role="table" aria-busy="false" aria-colcount="3" class="table b-table custom-fb-table mt-2 table-striped table-responsive table-hover" id="__BVID__50">
                <thead role="rowgroup" class="">
                  <tr role="row" class="">
                    <th role="columnheader" scope="col" aria-colindex="1" class="">
                      <div>Medication</div>
                    </th>
                    <th role="columnheader" scope="col" aria-colindex="1" class="">
                      <div>Effective Date</div>
                    </th>
                    <th role="columnheader" scope="col" aria-colindex="1" class="">
                      <div>Substitution Allowed</div>
                    </th>
                    <th role="columnheader" scope="col" aria-colindex="1" class="">
                      <div>Day Supply</div>
                    </th>
                    <th role="columnheader" scope="col" aria-colindex="1" class="">
                      <div>Sig</div>
                    </th>
                    <th role="columnheader" scope="col" aria-colindex="2" class="">
                      <div>Dispense</div>
                    </th>
                    <th role="columnheader" scope="col" aria-colindex="2" class="">
                      <div>Number of Refills</div>
                    </th>
                    <th role="columnheader" scope="col" aria-colindex="3">
                      <div>Date</div>
                    </th>
                  </tr>
                </thead>
                <tbody role="rowgroup">
                ${(this.tableProperties.items || [])
                  .map(
                    (item) => `
                  <tr role="row" class="">
                    <td aria-colindex="1" role="cell" class="" style="min-width: 130px;">${item.medication}</td>
                    <td aria-colindex="1" role="cell" class="" style="min-width: 130px;">${item.effectiveDate}</td>
                    <td aria-colindex="1" role="cell" class="" style="min-width: 130px;">${item.substitutionAllowed}</td>
                    <td aria-colindex="1" role="cell" class="" style="min-width: 130px;">${item.daySupply}</td>
                    <td aria-colindex="1" role="cell" class="" style="min-width: 130px;">${item.sig}</td>
                    <td aria-colindex="2" role="cell" class="" style="min-width: 130px;">${item.dispense}</td>
                    <td aria-colindex="2" role="cell" class="" style="min-width: 130px;">${item.numberOfRefills}</td>
                    <td aria-colindex="3" role="cell" style="min-width: 130px;">${item.date}</td>
                  </tr>
                `
                  )
                  .join("")}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </fieldset>`;
    },
    fetchMedications() {
      if (this.showType == "form-submitter" || this.showType == "e-form") {
        doseSpotServer
          .query(this.client.id)
          .then((doseSpotList) => {
            this.doseSpotErrorMessage = null;
            this.medications = doseSpotList.map((medication) => ({
              ...medication,
            }));
          })
          .catch((error) => {
            this.medications = [];
            if (error.response.data.errorCode == "doseSpotDisabled") {
              this.doseSpotErrorMessage =
                "Your tenant doesn't have DoseSpot enabled. Please contact your administrator to get access.";
            }
            if (error.response.data.errorCode == "currentUserWithoutAccess") {
              this.doseSpotErrorMessage =
                "Your account doesn't have DoseSpot access. Please contact your administrator to get access.";
            }
            if (error.response.data.errorCode == "patientNotSynchronized") {
              this.doseSpotErrorMessage =
                "This patient has not been synced with DoseSpot. Please synchronize the patient before using this component.";
            }
          });
      }
    },
  },
  computed: {
    ...mapGetters("formSubmitter", [
      "getFormSubmitterComponentValue"
    ]),
    ...mapState("formSubmitter", {
      client: (state) => state.form.client,
      currentPage: (state) => state.form.currentPage,
    }),
    computedPropertiesForm() {
      return this.$store.state.formSubmitter.form.computedProperties[this.id] ?? this.properties;
    },
    tableProperties() {
      let items = this.medications;
      return {
        ...this.properties,
        items: items,
        columns: [
          {
            key: "medication",
            label: "Medication",
          },
          {
            key: "effectiveDate",
            label: "Effective Date",
          },
          {
            key: "substitutionAllowed",
            label: "Substitution Allowed",
          },
          {
            key: "daySupply",
            label: "Day Supply",
          },
          {
            key: "sig",
            label: "Sig",
          },
          {
            key: "dispense",
            label: "Dispense",
          },
          {
            key: "numberOfRefills",
            label: "Number of Refills",
          },
          {
            key: "date",
            label: "Date",
          },
        ],
      };
    },
    computedHidden() {
      const hiddenValue = this.computedConditions.hidden
        ? this.computedPropertiesForm.hidden
        : this.properties.hidden

      this.$emit("change-hidden-property", hiddenValue);
      return hiddenValue;
    },
  },
};
</script>

<style scoped>
.medication-table-container >>> td {
  min-width: 130px;
}
.custom-fb-table th,
.custom-fb-table td {
  padding: 5px !important;
  vertical-align: middle !important;
}
.custom-fb-table td {
  font-size: 12px;
  padding-left: 17px;
}
.custom-fb-table th {
  font-size: 14px;
  padding-left: 17px;
}
</style>
